import React, { Component } from "react";

class Stater extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pris: this.props.pris2,
      cm: 31,
      active26: false,
      active31: true,
      active37: false,
      knapp: this.props.mppid2,
    };

    this.handleClick26 = this.handleClick26.bind(this);
    this.handleClick31 = this.handleClick31.bind(this);
    this.handleClick37 = this.handleClick37.bind(this);
  }

  handleClick26(e) {
    console.log("Clicked 26");

    this.setState({
      pris: this.props.pris1,
      cm: 26,
      active26: true,
      active31: false,
      active37: false,
      knapp: this.props.mppid1,
    });
    this.props.handleChildChange("26cm");
  }

  handleClick31(e) {
    console.log("Clicked 31");
    this.props.handleChildChange("31cm");
    this.setState({
      pris: this.props.pris2,
      cm: 31,
      active26: false,
      active31: true,
      active37: false,
      knapp: this.props.mppid2,
    });
  }

  handleClick37(e) {
    console.log("Clicked 37");
    this.props.handleChildChange("37cm");
    this.setState({
      pris: this.props.pris3,
      cm: 37,
      active26: false,
      active31: false,
      active37: true,
      knapp: this.props.mppid3,
    });
  }

  render() {
    return (
      <div>
        <div>
          {this.state.active26 === true ? (
            <button onClick={this.handleClick26} className="btn btn-warning mr-2 mb-2">
              26
            </button>
          ) : (
            <button onClick={this.handleClick26} className="btn btn-outline-secondary mr-2 mb-2">
              26
            </button>
          )}
          {this.state.active31 === true ? (
            <button onClick={this.handleClick31} className="btn btn-warning mr-2 mb-2">
              31
            </button>
          ) : (
            <button onClick={this.handleClick31} className="btn btn-outline-secondary mr-2 mb-2">
              31
            </button>
          )}
          {this.state.active37 === true ? (
            <button onClick={this.handleClick37} className="btn btn-warning mr-2 mb-2">
              37
            </button>
          ) : (
            <button onClick={this.handleClick37} className="btn btn-outline-secondary mr-2 mb-2">
              37
            </button>
          )}
          <h3>{this.state.pris}</h3>
          {this.state.cm} cm vingespenn
          <a href={this.state.knapp} className="btn btn-block btn-lg btn-success mt-4 mr-4">
            Kjøp nå
          </a>
        </div>
      </div>
    );
  }
}

export default Stater;
